export default __webpack_public_path__ + "static/media/Dataset.a1e39639.svg";